<template>
  <div class="chooseBank">
    <header class="page-header">
      <div class="title">选择免费办理ETC方式

        <div @click="showInfoBox=true" class="info-btn">
          <img class="info-btn-img" src="https://wecos.etczs.net/H5/newApply/icon-blue-info.png" alt="">
        </div>
      </div>
      <p class="sub-title">选择微信支付已绑定的银行卡，用于高速通行扣费</p>
      <div class="tags">
        <div class="tag">
          全国通行95折
        </div>
        <div class="tag">
          一年免费高速意外险
        </div>
      </div>
    </header>
    <section class="page-content">
      <div class="bank-card" :class="choosedBank.credit_card_bank === bank.credit_card_bank ? 'choosed' : ''" v-for="(bank, i) in banks" :key="i" @click="chooseBank(bank)">
        <div class="choose-icon" v-if="appChannel==='pingankoudai' && choosedBank.credit_card_bank === bank.credit_card_bank">
          <i class="iconfont etc-icon-gou-s"></i>
        </div>
        <div class="bank">
          <img :src="bank.img_url" alt="">
          <div><span class="name">{{bank.title}}</span><!-- <span class="type">{{bank.type}}</span> -->
            <p class="bank-tip">
              通过微信支付从{{bank.title}}卡扣费
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="bank-card">
        <div class="bank"><img src="https://wecos.etczs.net/H5/newApply/other-bank.png" alt="">
          <div><span class="name">其他银行</span>
            <p class="bank-tip">
              绑定微信支付，即可免费办理
            </p>
          </div>
        </div>
      </div> -->
    </section>
    <section class="page-bottom">
      <img src="https://wecos.etczs.net/H5/newApply/etc-logo.png" alt="" class="logo">
      <img src="https://wecos.etczs.net/H5/newApply/wepay-logo.png" alt="" class="logo">
    </section>
    <popup-box title="ETC办理方式说明" @close="showInfoBox=false" :show="showInfoBox">
      <dl class="info-list">
        <dt>选择办理方式的原因</dt>
        <dd>ETC设备由合作银行免费提供给用户</dd>
        <dd>需要绑定制定银行卡（用于ETC通行扣费）</dd>
        <dd>需遵守银行服务协议</dd>
      </dl>
      <div class="links">
        <span @click="m_customService" class="link">客服中心</span>
        <!-- &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
        <span @click="m_goPages('applyDetail')" class="link">办理详情</span> -->
      </div>
    </popup-box>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
import BiMixin from '@/mixins/biMixin'
// config
import ETC from '@/config/etc.config'
// components
// import Popup from '@/components/cool.popup'
import popupBox from './components/popup-box'
// store
import { mapState, mapMutations } from 'vuex'
// api
import NewApplyApi from '@/api/newApply.api'

export default {
  name: 'chooseBank',
  mixins: [FunMixin, BiMixin],
  components: {
    // Popup
    popupBox
  },
  data() {
    return {
      banks: [],
      choosedBank: '',
      showInfoBox: false
    }
  },
  computed: {
    ...mapState(['currentOrder', 'currentCard', 'newApplyInfo', 'applyOrderInfo'])
  },
  methods: {
    async pakdApply() {
      this.m_showLoading()
      try {
        await NewApplyApi.pakdApply({
          pre_bind_bank: this.choosedBank.credit_card_bank
        })
        localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, 'yes')
        location.href =
          ETC.PAKD_URL +
          `?uid=${localStorage.getItem(
            ETC.LOCAL_STORAGE_KEY.ETC_UID
          )}&plate_no=${this.newApplyInfo.plate_no ||
            this.currentOrder.plate_no ||
            ''}&order_sn=${this.currentOrder.order_sn}`
      } finally {
        this.m_loadingClose()
      }
    },
    showTip(i) {
      this.banks[i].showTip = !this.banks[i].showTip
      this.$forceUpdate()
    },
    async chooseBank(b) {
      this.m_showLoading()
      this.choosedBank = b
      this.resetChooseBank(b)
      try {
        this.m_goPages('goodsPay')
      } catch (e) {
      } finally {
        this.m_loadingClose()
      }
    },
    noBank() {
      this.m_goPages('optionBank')
    },
    ...mapMutations(['setChooseBank', 'resetChooseBank'])
  },
  mounted() {
    let plateNo1 = (
      this.newApplyInfo.plate_no ||
      this.currentOrder.plate_no ||
      ''
    ).substr(0, 1)
    console.log(plateNo1)

    this.banks = ETC.CHOOSE_BANKS.filter((v, i) => {
      return v.issuer === 25 // 捷通存量卡
    })
  }
}
</script>

<style scoped lang="scss">
@import '../../style/cool.practical';

.chooseBank {
  .page-header {
    border-bottom: 20px solid #f5f5f5;
    padding: 30px 40px;
    .title {
      font-size: 36px;
      color: #333;
      font-weight: bold;
      position: relative;
      .info-btn {
        position: absolute;
        right: -20px;
        top: -20px;
        padding: 20px;
      }
      .info-btn-img {
        width: 48px;
        height: 48px;
      }
    }
    .sub-title {
      color: #666666;
      font-size: 28px;
      margin-top: 16px;
    }
    .tags {
      margin-top: 12px;
      .tag {
        display: inline-block;
        margin-right: 20px;
        padding: 8px 24px 7px 24px;
        border-radius: 26px;
        line-height: 1;
        background: rgba(22, 200, 139, 0.1);
        color: #16c88b;
        font-size: 24px;
      }
    }
  }
  .page-content {
    padding: 30px 40px 150px;
    padding-bottom: 100px;
    .title {
      line-height: 45px;
      font-size: 32px;
      font-weight: bold;
      text-align: center;
    }
    .sub-title {
      line-height: 37px;
      font-size: 26px;
      color: #666666;
      margin-top: 10px;
      text-align: center;
    }
    .bank-card {
      margin-top: 30px;
      border: 2px solid #dddddd;
      border-radius: 10px;
      padding: 40px 30px;
      .bank {
        // padding-bottom: 30px;
        // border-bottom: 1px dashed #cccccc;
        @extend %flex-center-start;
        img {
          width: 100px;
          height: 100px;
          margin-right: 20px;
        }
        .name {
          font-size: 32px;
        }
        .type {
          font-size: 24px;
        }
      }
      .bank-tip {
        line-height: 34px;
        margin-top: 20px;
        font-size: 28px;
        color: #666;
        @extend %flex-center-start;
        i {
          margin-left: 10px;
          font-size: 26px;
        }
      }
      .sub-tip {
        font-size: 24px;
        color: #666666;
        line-height: 40px;
        margin-top: 20px;
      }
    }
  }
  .page-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 26px 55px 20px;
    background: #f5f5f5;
    /* .no-bank-btn {
      color: #999999;
      border-color: #999999;
    } */
    text-align: center;
    .logo {
      height: 40px;
      margin: 0 20px;
    }
  }
  .bank-type-popup {
    padding: 40px 70px;
    .header {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      line-height: 50px;
    }
    .bank-type {
      border: 1px solid #cccccc;
      border-radius: 10px;
      padding: 40px 20px;
      @extend %flex-center-start;
      height: 50px;
      font-size: 30px;
      color: #999999;
      box-sizing: content-box;
      margin-top: 40px;
      i {
        font-size: 40px;
        margin-right: 20px;
      }
      &.choosed {
        color: #333333;
        border-color: $primary-color;
        i {
          color: $primary-color;
        }
      }
    }
    .popup-footer {
      margin-top: 40px;
    }
  }
}

.info-list {
  margin-top: 20px;
  margin-bottom: 60px;
  dt {
    font-size: 32px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 14px;
  }
  dd {
    font-size: 28px;
    color: #666;
    display: list-item;
    list-style-type: disc;
    list-style-position: inside;
    padding-left: 20px;
    line-height: 1.6;
  }
}

.links {
  text-align: center;
  color: #dddddd;
  .link {
    font-size: 28px;
    color: #0094ee;
  }
}
</style>
